module.exports = __webpack_public_path__ + "static/media/repartologo.064da5ec.svg";